import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNextcloudComponent } from './simple-icons-nextcloud.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNextcloudComponent ],
    exports:      [ SimpleIconsNextcloudComponent ],
    bootstrap:    []
})
export class SimpleIconsNextcloudModule {}
